'use client';

import Image from './Image';
import withClientTheme from '../utils/theming/with-client-theme';

// Exporting the unwrapped component separately for react-docgen to extract info for docsite
export { Image as DefaultImage };
const ClientThemedImage = withClientTheme(Image);
export default ClientThemedImage;